import { raise } from '@sparkdotfi/common-universal'
import { arbitrum, avalanche, base, gnosis, optimism, unichain } from 'viem/chains'

import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export interface GetSavingsWithdrawActionPathParams {
  token: Token
  savingsToken: Token
  chainId: number
}

export type SavingsWithdrawActionPath =
  // v2
  | 'spusdc-to-usdc'
  | 'spusdt-to-usdt'
  | 'speth-to-weth'
  | 'speth-to-eth'
  | 'sppyusd-to-pyusd'
  // sky
  | 'susds-to-usds'
  | 'susds-to-usdc'
  // legacy
  | 'susdc-to-usdc'
  | 'sdai-to-dai'
  | 'sdai-to-usds'
  | 'sdai-to-sexy-dai'
  // base
  | 'base-susds-to-usdc'
  | 'base-susds-to-usds'
  | 'base-susdc-to-usdc'
  // arbitrum
  | 'arbitrum-susds-to-usds'
  | 'arbitrum-susds-to-usdc'
  | 'arbitrum-susdc-to-usdc'
  // optimism
  | 'optimism-susds-to-usds'
  | 'optimism-susds-to-usdc'
  | 'optimism-susdc-to-usdc'
  // unichain
  | 'unichain-susds-to-usds'
  | 'unichain-susds-to-usdc'
  | 'unichain-susdc-to-usdc'
  // avalanche
  | 'avalanche-spusdc-to-usdc'
  // opportunities
  | 'stusds-to-usds'

export function getSavingsWithdrawActionPath({
  token,
  savingsToken,
  chainId,
}: GetSavingsWithdrawActionPathParams): SavingsWithdrawActionPath {
  const dai = TokenSymbol('DAI')
  const sdai = TokenSymbol('sDAI')
  const usds = TokenSymbol('USDS')
  const susds = TokenSymbol('sUSDS')
  const xdai = TokenSymbol('XDAI')
  const usdc = TokenSymbol('USDC')
  const susdc = TokenSymbol('sUSDC')
  const usdt = TokenSymbol('USDT')
  const weth = TokenSymbol('WETH')
  const eth = TokenSymbol('ETH')
  const stusds = TokenSymbol('stUSDS')
  const spusdc = TokenSymbol('spUSDC')
  const spusdt = TokenSymbol('spUSDT')
  const speth = TokenSymbol('spETH')
  const pyusd = TokenSymbol('PYUSD')
  const sppyusd = TokenSymbol('spPYUSD')

  if (token.symbol === xdai && savingsToken.symbol === sdai && chainId === gnosis.id) {
    return 'sdai-to-sexy-dai'
  }

  if (chainId === base.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'base-susds-to-usds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'base-susds-to-usdc'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'base-susdc-to-usdc'
    }
  }

  if (chainId === arbitrum.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'arbitrum-susds-to-usds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'arbitrum-susds-to-usdc'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'arbitrum-susdc-to-usdc'
    }
  }

  if (chainId === optimism.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'optimism-susds-to-usds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'optimism-susds-to-usdc'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'optimism-susdc-to-usdc'
    }
  }

  if (chainId === unichain.id) {
    if (token.symbol === usds && savingsToken.symbol === susds) {
      return 'unichain-susds-to-usds'
    }

    if (token.symbol === usdc && savingsToken.symbol === susds) {
      return 'unichain-susds-to-usdc'
    }

    if (token.symbol === usdc && savingsToken.symbol === susdc) {
      return 'unichain-susdc-to-usdc'
    }
  }

  if (chainId === avalanche.id) {
    if (token.symbol === usdc && savingsToken.symbol === spusdc) {
      return 'avalanche-spusdc-to-usdc'
    }
  }

  if (token.symbol === usds && savingsToken.symbol === susds) {
    return 'susds-to-usds'
  }

  if (token.symbol === usdc && savingsToken.symbol === susds) {
    return 'susds-to-usdc'
  }

  if (token.symbol === dai && savingsToken.symbol === sdai) {
    return 'sdai-to-dai'
  }

  if (token.symbol === usds && savingsToken.symbol === sdai) {
    return 'sdai-to-usds'
  }

  if (token.symbol === usdc && savingsToken.symbol === susdc) {
    return 'susdc-to-usdc'
  }

  if (token.symbol === usds && savingsToken.symbol === stusds) {
    return 'stusds-to-usds'
  }

  if (token.symbol === usdc && savingsToken.symbol === spusdc) {
    return 'spusdc-to-usdc'
  }

  if (token.symbol === usdt && savingsToken.symbol === spusdt) {
    return 'spusdt-to-usdt'
  }

  if (token.symbol === weth && savingsToken.symbol === speth) {
    return 'speth-to-weth'
  }

  if (token.symbol === eth && savingsToken.symbol === speth) {
    return 'speth-to-eth'
  }

  if (token.symbol === pyusd && savingsToken.symbol === sppyusd) {
    return 'sppyusd-to-pyusd'
  }

  raise('Savings action type not recognized')
}
